<template>
    <main-content>
        <requests-filter :action="filterAction"></requests-filter>
        <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
    </main-content>
</template>

<script>
    import $ from 'jquery'
    import { ApiUrl } from '@/common/api.service'
    import RequestsFilter from './components/requests-filter'
    import columns from './datatable/columns'
    import { AuthorizationHeader } from '@/common/jwt.service'
    import mainContent from '@/components/main-content'

    export default {
        name: 'shaparak_requests_get',
        components: {
            mainContent,
            'requests-filter': RequestsFilter
        },
        data() {
            return {
                headerAction: {
                    left: '10px',
                    top: '10px',
                    position: 'absolute'
                },
                query: {}
            }
        },
        computed: {
            datatableProps() {
                return {
                    id: "shaparak_requests_datatable",
                    data: {
                        type: 'remote',
                        source: {
                            read: {
                                url: ApiUrl.path('shaparak/get-shaparak-requests'),
                                method: 'GET',
                                headers: AuthorizationHeader,
                                map: (res) => {
                                    return res.data.data
                                },
                                params: {
                                    query: this.query
                                },
                            }
                        },
                        pageSize: 15,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                    },

                    pagination: false,
                    sortable: true,
                    columns: columns,
                    // actions: actions
                }
            }
        },
        methods: {
            filterAction(e, query) {
                this.query = query
                if (this.$refs.datatable.KTDatatable) {
                    this.$refs.datatable.reload()
                }
            },
        }
    }
</script>

<style>

</style>